type RouterDirection = 'back' | 'forward' | 'none' | 'root'
type RouteAction = 'pop' | 'push' | 'replace'

type PushRouter = {
	push: (
		pathname: string,
		routerDirection?: RouterDirection,
		routeAction?: RouteAction,
	) => void
}

type BackOrPushRouter = PushRouter & {
	routeInfo: {
		pushedByRoute?: string
	}
	canGoBack: () => boolean
	goBack: () => void
}

export function pushOrGoBackToPreviousPage(router: BackOrPushRouter, targetUrl: string) {
	if (
		router.canGoBack() &&
		router.routeInfo.pushedByRoute &&
		normalizePathname(pathnameFromUrl(targetUrl)) === normalizePathname(router.routeInfo.pushedByRoute)
	) {
		router.goBack()
		return
	}

	router.push(targetUrl, 'forward', 'push')
}

export function pushTeamSeasonRoot(router: PushRouter, targetUrl: string) {
	// Team/season changes alter the global Section context. Make the selected
	// season the new Ionic tab root so re-tapping Games cannot reset to an older
	// team's first /games URL, while keeping browser Back history intact.
	router.push(targetUrl, 'root', 'push')
}

function pathnameFromUrl(url: string) {
	return new URL(url, window.location.origin).pathname
}

function normalizePathname(pathname: string) {
	return pathname.length > 1 && pathname.endsWith('/')
		? pathname.slice(0, -1)
		: pathname
}
